import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class SearchService{
	_searching: boolean=false;
	readonly searchEvent: EventEmitter<boolean>=new EventEmitter<boolean>();

	set searching(val: boolean){
		this._searching=val;
		this.searchEvent.emit(val);
	}

	get searching(){
		return this._searching;
	}

	search(search: boolean){
		this.searching=search;
	}

}